import { Typography } from "@mui/material";
import { format } from "date-fns";
import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { pages } from "../pages/pages";
import { getExercisesByCategory } from "../utils/exercises";
import { secondsToTime } from "../utils/timeHelpers";
import { GetSessionsType } from "./Profile.gql";
import { ChipWrapper, SessionContainer, SessionHeadline, StyledChip } from "./Profile.sc";

interface SessionListProps {
    data: GetSessionsType;
}

const SessionsList: React.FunctionComponent<SessionListProps> = ({ data }) => {
    const { sessions } = data;
    const { t } = useTranslation();

    const navigate = useNavigate();

    return (
        <>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline" }}>
                <Typography color="primary" fontWeight="700" style={{ marginTop: 20, marginBottom: 10, fontSize: 20 }}>
                    {t("completed_sessions")}
                </Typography>
                <Typography style={{ fontSize: 18 }}>
                    {sessions.nodes.length}/{sessions.totalCount}
                </Typography>
            </div>
            {sessions.nodes.map((session, index) => {
                const sessionByCategory = getExercisesByCategory(session.exercises);

                return (
                    <SessionContainer key={index} onClick={() => navigate(pages.session, { state: { session } })}>
                        <SessionHeadline>
                            <Typography fontWeight={700}>{t("exercise_session")}</Typography>
                            <Typography>{format(new Date(session.createdAt), "dd.MM.yyyy")}</Typography>
                        </SessionHeadline>
                        <Typography style={{ marginTop: 10 }}>{t("minutes_total", { minutes: secondsToTime(session.durationTotal) })}</Typography>
                        <ChipWrapper>
                            {Object.keys(sessionByCategory).map((category) => (
                                <StyledChip key={`${category}${index}`} label={t(category)} category={category as keyof typeof sessionByCategory} />
                            ))}
                        </ChipWrapper>
                    </SessionContainer>
                );
            })}
        </>
    );
};

export default SessionsList;
